import 'antd/lib/table/style/index'
import 'antd/lib/button/style/index'
import 'antd/lib/select/style/index'
import 'antd/lib/space/style/index'
import 'antd/lib/badge/style/index'
import 'antd/lib/pagination/style/index'
import './style.less'
